export default "__VITE_ASSET__0bf78651__"